import React from 'react';
import { Check, Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { AnalysisStage } from '@/types/analysisProgress';
import { STAGES } from '@/types/analysisProgress';

interface AnalysisStageListProps {
  currentStage: AnalysisStage;
  className?: string;
}

export function AnalysisStageList({ currentStage, className }: AnalysisStageListProps) {
  // Get the 4 main stages (excluding 'complete')
  const mainStages = STAGES.filter(s => s.stage !== 'complete');
  const currentStageIndex = STAGES.findIndex(s => s.stage === currentStage);

  return (
    <div className={cn("space-y-4", className)}>
      {mainStages.map((stage, index) => {
        const stageIndex = STAGES.findIndex(s => s.stage === stage.stage);
        const isComplete = stageIndex < currentStageIndex;
        const isActive = stage.stage === currentStage;

        return (
          <div key={stage.stage} className="flex items-center gap-3">
            {/* Icon */}
            <div
              className={cn(
                "w-6 h-6 rounded-full flex items-center justify-center border-2 transition-all",
                isComplete
                  ? "bg-[#196644] border-[#196644]"
                  : isActive
                  ? "border-[#196644] bg-[#196644]/10"
                  : "border-gray-300 bg-white"
              )}
            >
              {isComplete ? (
                <Check className="w-4 h-4 text-white" />
              ) : isActive ? (
                <Loader2 className="w-4 h-4 text-[#196644] animate-spin" />
              ) : (
                <div className="w-2 h-2 rounded-full bg-gray-300" />
              )}
            </div>
            {/* Label */}
            <span
              className={cn(
                "text-sm transition-colors",
                isComplete
                  ? "text-gray-600"
                  : isActive
                  ? "text-[#0D382A] font-medium"
                  : "text-gray-400"
              )}
            >
              {stage.label}
              {isActive && '...'}
            </span>
          </div>
        );
      })}
    </div>
  );
}

